<h1 [innerHtml]="page.heading"></h1>
<div class="fc-static-content" [innerHtml]="page.pageContent | marked"></div>
<fc-category-card [items]="page.comparisonCategories"></fc-category-card>